module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filter_expense":"Filter expense"},"id":{"filter_expense":"Filter biaya"}}')
  delete Component.options._Ctor
}
